var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoals(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1255_4053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V28H28V0H0ZM26.3594 1.64062V3.33594H1.64062V1.64062H26.3594ZM1.64062 26.3594V4.97656H26.3594V26.3594H1.64062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5391 6.61719H3.33594V11.5391H11.5391V6.61719ZM9.89844 9.89844H4.97656V8.25781H9.89844V9.89844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33594 24.6641H18.1016V19.7422H3.33594V24.6641ZM4.97656 21.3828H16.4609V23.0234H4.97656V21.3828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61719 18.1016H18.1016V13.1797H6.61719V18.1016ZM8.25781 14.8203H16.4609V16.4609H8.25781V14.8203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0233 8.25781H18.3005L15.6405 5.59778L12.1602 9.07812L15.6405 12.5585L18.3005 9.89844H21.3827V19.5431L18.7227 22.2031L22.203 25.6835L25.6833 22.2031L23.0233 19.5431V8.25781ZM15.6405 10.2383L14.4803 9.07812L15.6405 7.91794L16.8007 9.07812L15.6405 10.2383ZM22.203 23.3633L21.0428 22.2031L22.203 21.0429L23.3632 22.2031L22.203 23.3633Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1255_4053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoals);
export default __webpack_public_path__ + "static/media/goals.7879d162e791a9f5ee3e3288db2020e0.svg";
export { ForwardRef as ReactComponent };